<template>
    <div class="account">
        <!-- 库存商品列表（待修复） -->
        <vStockProductComponent :postList="postList" v-if="flag"></vStockProductComponent>
    </div>
</template>
<script>
import vStockProductComponent from '../../listComponent/basicdata/repertoryList/stockProductListComponent.vue';
export default {
    name: 'stockProductList',
    components: {
        vStockProductComponent
    },
    data() {
        return {
            postList: {
                headerTitle: true,
                source_file: true,
                batchSaveBtn: true,
                searchBtn: true,
                resetBtn: true,
                setBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>